import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@pwc/appkit-react/lib/Modal';
import { Resizable } from 'react-resizable';
import { Helmet } from 'react-helmet';

import PageHelpContainer from './pageHelpContainer.component';

const getNewMarginRight = (initialWidth, width) => {
  const initialMarginRight = 80;

  const newMarginRight = (width - initialWidth) + initialMarginRight;

  return newMarginRight > initialMarginRight ? newMarginRight : initialMarginRight;
};
const getNewArrowRightValue = (initialWidth, width) => {
  const initialArrowRightValue = '6.6rem';

  const newArrowRightValue = width - initialWidth;

  return newArrowRightValue > 0 ? `calc(${initialArrowRightValue} - ${newArrowRightValue}px)` : initialArrowRightValue;
};
const generateCSS = (initialWidth, width) => `
  .page-help-wrapper {
    /* Styles generated dynamically in pageHelpModal component */
    margin-right: ${getNewMarginRight(initialWidth, width)}px;
    width: ${width}px;
  }
  .page-help-wrapper::before {
    /* Styles generated dynamically in pageHelpModal component */
    right: ${getNewArrowRightValue(initialWidth, width)}
  }
  .page-help-wrapper .modal-content {
    /* Styles generated dynamically in pageHelpModal component */
    width: ${width}px
  }
`;

const PageHelpModal = ({
  helpOpened,
  toggleHelpModal,
}) => {
  const initialWidth = 560;
  const initialHeight = 615;
  const [width, setWidth] = useState(initialWidth);
  const [height, setHeight] = useState(initialHeight);
  const handleResize = useCallback((event, resize) => {
    if (!resize?.size) {
      return;
    }
    setWidth(resize.size.width);
    setHeight(resize.size.height);
  }, []);

  return (
    <>
      <Helmet>
        <style type="text/css">{generateCSS(initialWidth, width)}</style>
      </Helmet>
      <Modal
        className="page-help-wrapper"
        visible={helpOpened}
        onCancel={toggleHelpModal}
        zIndex={90000}
      >
        <Resizable
          width={width}
          height={height}
          minConstraints={[initialWidth, 200]}
          onResize={handleResize}
          resizeHandles={['sw', 'w', 's']}
          axis="both"
        >
          <div style={{ height: `${height}px`, width: `${width}px` }}>
            <PageHelpContainer toggleHelpModal={toggleHelpModal}/>
          </div>
        </Resizable>
      </Modal>
    </>
  );
};

PageHelpModal.propTypes = {
  helpOpened: PropTypes.bool.isRequired,
  toggleHelpModal: PropTypes.func.isRequired,
};

export default PageHelpModal;
